import moment from "moment";
import { useTranslation } from "react-i18next";
import { ITransactionUsdt } from "../../../interfaces";
import { Numeral } from "../../Numeral";

interface WalletUsdtTransactionProps {
  transactions: ITransactionUsdt[],
  address: string
}
export const WalletUsdtTransaction = ({ address, transactions }: WalletUsdtTransactionProps) => {
  const { t } = useTranslation()
  return (
    <>
      <table className="table mb-0">
        <tbody>
          <tr>
            <td className="py-3">
              <div className="row m-0">
                {
                  transactions && transactions.map((trx: ITransactionUsdt, index) => {
                    let sign = '';
                    if (trx.from === address) {
                      sign = '-'
                    } else if (trx.to === address) {
                      sign = '+'
                    }
                    return (
                      <div key={index} className="ol-12 col-sm-6 mb-2">
                        {sign === '-' && <div className="">
                          <div className="text-xs greendeal">
                            <div className="d-flex justify-between mb-1">
                              <div>
                                <span className="badge bg-slate-400 me-2" style={{ fontSize: '8px' }}>USDT</span>
                                {`${moment(new Date(trx.block_timestamp)).format('YYYY-MM-DD HH:mm:ss')}`}
                              </div>
                              <div className="weight-600">- <Numeral value={Number(trx.value) * 0.000001} /></div>
                            </div>
                            <div className="text-start break-all text-gray-400">{trx.to}</div>
                          </div>
                        </div>}
                        {sign === '+' && <div className="">
                          <div className="text-xs reddeal">
                            <div className="d-flex justify-between mb-1">
                              <div>
                                <span className="badge bg-slate-400 me-2" style={{ fontSize: '8px' }}>USDT</span>
                                {`${moment(new Date(trx.block_timestamp)).format('YYYY-MM-DD HH:mm:ss')}`}
                              </div>
                              <div className="weight-600">+ <Numeral value={Number(trx.value) * 0.000001} /></div>
                            </div>
                            <div className="text-start break-all text-gray-400">{trx.from}</div>
                          </div>
                        </div>}
                      </div>
                    )
                  })
                }
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}